import onWindowResize from "./windowResize";
import { _debounce } from "./until";

function resize() {
  onWindowResize.add(_debounce(setSize, 50))
  window.onload = setSize()
}

// 修改fontsize的值
function setSize() {
  var deviceWidth = document.documentElement.clientWidth
  document.documentElement.style.fontSize = (deviceWidth / 375) + 'px'
}

export default resize


// WEBPACK FOOTER //
// ./src/lib/js/resize.js